import { ref, onUnmounted, type Ref } from "vue";

export const WORKSPACE_3UP_MIN_PX = 1200;

export function useResponsiveBreakpoint(minWidth: number): { matches: Ref<boolean> } {
  if (typeof window === "undefined") {
    return { matches: ref(false) };
  }

  const mql = window.matchMedia(`(min-width: ${minWidth}px)`);
  const matches = ref<boolean>(mql.matches);

  const handler = (e: MediaQueryListEvent) => {
    matches.value = e.matches;
  };

  mql.addEventListener("change", handler);

  onUnmounted(() => {
    mql.removeEventListener("change", handler);
  });

  return { matches };
}
